import React from 'react';
import { motion } from 'framer-motion';
import { testimonialsFull } from '../data/salesData';
import { StarIcon } from 'lucide-react';
export function TestimonialsFull() {
  return <section className="py-16 px-4 bg-surface-light" data-id="element-247">
      <div className="max-w-6xl mx-auto" data-id="element-248">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-249">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-primary" data-id="element-250">
            Lo que dicen los instructores
          </h2>
          <div className="flex items-center justify-center gap-2 text-2xl" data-id="element-251">
            <span className="font-bold text-gray-900" data-id="element-252">4.9/5</span>
            <div className="flex" data-id="element-253">
              {[1, 2, 3, 4, 5].map(i => <StarIcon key={i} className="w-6 h-6 fill-highlight text-highlight" data-id="element-254" />)}
            </div>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-255">
          {testimonialsFull.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index % 2 * 0.1
        }} className="bg-white rounded-lg p-6 shadow-sm border border-gray-200" data-id="element-256">
              <div className="flex gap-0.5 mb-4" data-id="element-257">
                {[1, 2, 3, 4, 5].map(i => <StarIcon key={i} className="w-5 h-5 fill-highlight text-highlight" data-id="element-258" />)}
              </div>
              <div className="flex items-start gap-4 mb-4" data-id="element-259">
                <div className="w-12 h-12 rounded-full bg-primary text-white flex items-center justify-center font-bold flex-shrink-0" data-id="element-260">
                  {testimonial.initials}
                </div>
                <div data-id="element-261">
                  <p className="font-semibold text-gray-900" data-id="element-262">
                    {testimonial.name}
                  </p>
                  <p className="text-sm text-gray-600" data-id="element-263">{testimonial.city} 🇦🇷</p>
                </div>
              </div>
              <p className="text-gray-700 italic" data-id="element-264">"{testimonial.quote}"</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}